import type { Student } from '@/services/contribution/contribution'
import { useTranslation } from 'react-i18next'

export function StudentListHeader() {
  const columnStyling = `py-2 px-1 text-sm font-semibold text-gray-700 sm:pl-0`
  const { t } = useTranslation()
  return (
    <tr>
      <th scope='col' className={`${columnStyling} text-left`}>
        {t('content.components.current_students.name_column_title')}
      </th>
      <th scope='col' className={`${columnStyling} text-left`}>
        {t('content.components.current_students.status_column_title')}
      </th>
    </tr>
  )
}

export function StudentListItem({ student, onClick }: { student: Student; onClick: (student: Student) => void }) {
  const rowStyling =
    'whitespace-nowrap py-3 px-1 text-sm text-gray-500 group-hover:bg-gray-100 group-hover:cursor-pointer'
  return (
    <tr className='group' onClick={() => onClick(student)}>
      <td className={`${rowStyling} text-left`}>
        {student.firstName} {student.lastName}
      </td>
      <td className={`${rowStyling} text-left `}>
        <div className='max-w-4/5 sm:max-w-none whitespace-nowrap overflow-x-hidden text-ellipsis'>
          {student?.classroom?.name ?? 'Other'}
        </div>
      </td>
    </tr>
  )
}
